import React from "react";
import { StyledProfileMenuCard } from "./index.styled";
import { Flex, Typography } from "antd";
import PropTypes from "prop-types";

const ProfileMenuCard = (props) => {
  const { items } = props;
  return (
    <StyledProfileMenuCard gap={16} vertical>
      {Array.isArray(items) &&
        items.map(({ icon, title, subtitle, onClick }) => (
          <Flex gap={16} align="center" onClick={onClick}>
            {icon}
            <Flex vertical justify="space-between">
              <Text>{title}</Text>
              <Text type="secondary">{subtitle}</Text>
            </Flex>
          </Flex>
        ))}
    </StyledProfileMenuCard>
  );
};

const { Text } = Typography;

ProfileMenuCard.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      onClick: PropTypes.func,
    })
  ).isRequired,
};

export default ProfileMenuCard;
